import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ReportOPEEnum} from "./ReportOPEEnum";
import {AggregateFunctionTypeEnum, BucketUnitEnum} from "../../enums/dashboard/ChartsEnum";

class O {
}

class I {
  id?: number;
}

export class ExecUserReportCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(ReportOPEEnum.ExecUserReport);
    this.i = new I();
    this.o = new O();
  }
}
